import React from 'react';
import { WiStormShowers } from 'weather-icons-react';
import { Icon } from '@iconify/react';
import fireIcon from '@iconify-icons/emojione/fire';
import volcanoIcon from '@iconify-icons/twemoji/volcano';
import snowmanWithoutSnow from '@iconify-icons/emojione-v1/snowman-without-snow';
import iceShelfMelting from '@iconify-icons/openmoji/ice-shelf-melting';
import droughtIcon from '@iconify-icons/carbon/drought';
import fileTypeDustjs from '@iconify-icons/vscode-icons/file-type-dustjs';
import earthquakeIcon from '@iconify-icons/openmoji/earthquake';
import floodIcon from '@iconify-icons/openmoji/flood';
import temperatureTaking from '@iconify-icons/openmoji/temperature-taking';

function LocationMarker({ selected, type, onClick }) {
  return (
    <div className='location-marker' onClick={onClick}>
      {(() => {
        if (type === 'wildfires' && selected[1]) {
          return <Icon icon={fireIcon} height={30} width={30} />;
        } else if (type === 'volcanoes' && selected[2]) {
          return <Icon icon={volcanoIcon} height={30} width={30} />;
        } else if (type === 'severeStorms' && selected[3]) {
          return <WiStormShowers size={30} color='#00F' />;
        } else if (type === 'seaLakeIce' && selected[4]) {
          return <Icon icon={iceShelfMelting} height={30} width={30} />;
        } else if (type === 'snow' && selected[5]) {
          return <Icon icon={snowmanWithoutSnow} height={30} width={30} />;
        } else if (type === 'drought' && selected[6]) {
          return <Icon icon={droughtIcon} height={30} width={30} />;
        } else if (type === 'dustHaze' && selected[7]) {
          return <Icon icon={fileTypeDustjs} height={30} width={30} />;
        } else if (type === 'earthquakes' && selected[8]) {
          return <Icon icon={earthquakeIcon} height={30} width={30} />;
        } else if (type === 'floods' && selected[9]) {
          return <Icon icon={floodIcon} height={30} width={30} />;
        } else if (type === 'tempExtremes' && selected[10]) {
          return <Icon icon={temperatureTaking} height={30} width={30} />;
        } else return null;
      })()}
    </div>
  );
}
LocationMarker.defaultProps = {
  selected: [],
  type: '',
};
export default LocationMarker;
